import React, { useState, useRef } from 'react';

import { Input, Button, Select, Modal, Upload, message, Form, Space } from 'antd';
import ProTable, { ActionType } from '@ant-design/pro-table';
import axios from '../../../utils/AxiosUtil'
import { RollbackOutlined, DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import Invoice from '../../../components/invoice/index.tsx';
// import { procCols } from '../../../constants/processingConstants'
import { servedBillCol, htmlstyle, getHtmlStr } from '../../../constants/servedBillConstants'
import { axiosPostAndHint, mask, unmask } from '../../../components/reqAndHint'
import './proc.less'
import { excel2Json } from '../../../utils/XlsxUtil';
import date2Str from '../../../utils/date2Str';
import { useSelector } from 'react-redux'
import printJS from 'print-js'
import { statusObj2 } from '../../../utils/info.js';
import j2eUtil from '../../../utils/j2e';
export default (props) => {

    // console.log('svrdQuery:', props);
    const langValue = useSelector(state => state.langList.value)
    const actionRef = useRef<ActionType>();
    let col = [...servedBillCol];
    const [columns, setColumns] = useState(col);
    const [needSearchForm, setNeedSearchForm] = useState(true);//true表示搜索表单尚未动态加载
    const [selectedRowKeysArr, setSelectedRowkeysArr] = useState([]);
    const [selectedRowArr, setSelectedRowArr] = useState([]);
    const [recordArr, setRecordArr] = useState([])
    const [modalVisible, setModalVisible] = useState(false);
    const [number, setNumber] = useState('')
    const [start_number, setStartnumber] = useState('')
    const [end_number, setEndnumber] = useState('')
    const [open, setOpen] = useState(false)
    const [isBatch, setIsbatch] = useState(false)
    const [data, setData] = useState([])
    // 导入功能
    const handleUpload = async (file, billRecordId) => {
        // 票据代码
        let bill_index = null;

        Modal.confirm({
            title: '请输入票据代码：',
            content: <div>
                <Input
                    style={{ width: 250 }}
                    onChange={(e) => {
                        bill_index = e.target.value;
                        // console.log('bill_index:', bill_index);
                    }}
                ></Input>
            </div>,
            okText: '确定',
            cancelText: '取消',
            onOk: async () => {
                // console.log('bill_index:', bill_index);
                if (!bill_index) {
                    Modal.warning({ title: '请输入票据代码', okText: '知道了' });
                    return;
                }

                let json = await excel2Json(file, null);
                // console.log('json:', json);
                //只传给后台需要更新的序号和票据号码
                let bdJson = json.map((item, index) => {
                    return {
                        序号: item.序号,
                        票据号码: item.票据号码,
                        开票日期: item.开票日期,
                    }
                });
                // 获得用户名uname
                let uname = sessionStorage.getItem('uname');

                // axiosPostAndHint('/billmgt/importBillDetail', { bdJson, uname, billRecordId, bill_index },
                //     () => { actionRef.current?.reload() },
                //     () => { },
                //     120000);

                let data = await axios.post('/fund/billmgt/importBillDetail', { bdJson, uname, billRecordId, bill_index });
                // console.log('importBillDetail:', data?.data);
                if (data ?.data) {
                    let hintArr = data.data ?.hintArr;
                    Modal.info({
                        width: '30%',
                        title: data ?.data ?.msg,
                        content: (
                            <div style={{ fontSize: 16 }}>
                                {hintArr && hintArr.length > 0 && hintArr.map((h, i) => {
                                    return (<div key={i} style={{ marginTop: 7, marginBottom: 7 }}>{(i + 1) + '. ' + h}</div>)
                                })}
                            </div>
                        ),
                        onOk: () => { actionRef.current ?.reload() },
                        okText: langValue == 0 ? '确定Yes' : (langValue == 1 ? '确定' : 'Yes')
                    })
                } else {
                    Modal.error({
                        title: '导入失败',
                    })
                }


            },
            onCancel: () => { return false }
        })

    }


    // 下载excel
    // const handleDownload = () => {
    //     // console.log('handleDownload...');

    //     //先生成excel
    //     axiosPostAndHint('/billmgt/createExcel', { billRecordId: props.recordId,langValue },
    //         //成功的回调    
    //         () => {
    //             // console.log('生成excel成功:', props.recordCount);

    //             mask();
    //             //大于6w条记录，则需要从后端获取两个excel文件
    //             if (props.recordCount > 60000) {
    //                 let excelIndex1 = '-1';
    //                 axios({
    //                     url: '/fund/billmgt/downloadExcel', //调用的接口，该接口返回文件流
    //                     method: 'post',
    //                     params: {
    //                         //接口的参数
    //                         billRecordId: props.recordId,
    //                         //-1
    //                         excelIndex: excelIndex1
    //                     },
    //                     responseType: 'blob',
    //                     timeout: 120000,
    //                 }).then((response) => {
    //                     // console.log('downloadExcel response:', response);
    //                     unmask();
    //                     const url = window.URL.createObjectURL(new Blob([response.data]));
    //                     const link = document.createElement('a');
    //                     link.href = url;
    //                     //B表命名：地区编号+年月日时分秒
    //                     // console.log('response', response);
    //                     let areaCode = props.recordArea ?.replace(/\W|_/g, '');
    //                     let fileName = areaCode + ' ' + date2Str.format(new Date(), 'yyyy-MM-dd HH：mm：ss ') + excelIndex1 + '.xlsx';
    //                     link.setAttribute('download', fileName); //下载后的文件名为fileName
    //                     document.body.appendChild(link);
    //                     link.click();
    //                     document.body.removeChild(link);
    //                     message.destroy();
    //                     // message.info("请在浏览器下方查看文件，并等待下载完成", 10);

    //                 }).catch(e => {
    //                     unmask();
    //                     console.log(e);
    //                     Modal.error({ title: langValue==0?'出错了Error':(langValue==1?'出错了':'Error') })
    //                 });


    //                 let excelIndex2 = '-2';
    //                 axios({
    //                     url: '/fund/billmgt/downloadExcel', //调用的接口，该接口返回文件流
    //                     method: 'post',
    //                     params: {
    //                         //接口的参数
    //                         billRecordId: props.recordId,
    //                         //-1
    //                         excelIndex: excelIndex2
    //                     },
    //                     responseType: 'blob',
    //                     timeout: 120000,
    //                 }).then((response) => {
    //                     // console.log('downloadExcel response:', response);
    //                     unmask();
    //                     const url = window.URL.createObjectURL(new Blob([response.data]));
    //                     const link = document.createElement('a');
    //                     link.href = url;
    //                     //B表命名：地区编号+年月日时分秒
    //                     // console.log('response', response);
    //                     let areaCode = props.recordArea ?.replace(/\W|_/g, '');
    //                     let fileName = areaCode + ' ' + date2Str.format(new Date(), 'yyyy-MM-dd HH：mm：ss ') + excelIndex2 + '.xlsx';
    //                     link.setAttribute('download', fileName); //下载后的文件名为fileName
    //                     document.body.appendChild(link);
    //                     link.click();
    //                     document.body.removeChild(link);
    //                     message.destroy();
    //                     message.info(langValue==0?
    //                     <>记录较多将拆分为多个excel文件,请在浏览器下方查看，并等待下载完成<br/>If there are many records, they will be split into multiple Excel files. Please view them below the browser and wait for the download to complete</>:
    //                     (langValue==1?'记录较多将拆分为多个excel文件,请在浏览器下方查看，并等待下载完成':
    //                         'If there are many records, they will be split into multiple Excel files. Please view them below the browser and wait for the download to complete'), 10);

    //                 }).catch(e => {
    //                     unmask();
    //                     console.log(e);
    //                     Modal.error({ title: langValue==0?'出错了Error':(langValue==1?'出错了':'Error') })
    //                 });


    //             } else {

    //                 axios({
    //                     url: '/fund/billmgt/downloadExcel', //调用的接口，该接口返回文件流
    //                     method: 'post',
    //                     params: {
    //                         //接口的参数
    //                         billRecordId: props.recordId,
    //                     },
    //                     responseType: 'blob',
    //                     timeout: 120000,
    //                 }).then((response) => {
    //                     // console.log('downloadExcel response:', response);

    //                     unmask();
    //                     const url = window.URL.createObjectURL(new Blob([response.data]));
    //                     const link = document.createElement('a');
    //                     link.href = url;
    //                     //B表命名：地区编号+年月日时分秒
    //                     // console.log('response', response);
    //                     let areaCode = props.recordArea ?.replace(/\W|_/g, '');
    //                     let fileName = areaCode + ' ' + date2Str.format(new Date(), 'yyyy-MM-dd HH：mm：ss') + '.xlsx';
    //                     link.setAttribute('download', fileName); //下载后的文件名为fileName
    //                     document.body.appendChild(link);
    //                     link.click();
    //                     document.body.removeChild(link);
    //                     message.destroy();
    //                     message.info(langValue==0?<>请在浏览器下方查看文件，并等待下载完成<br/>Please view the file below the browser and wait for the download to complete</>:(langValue==1?'请在浏览器下方查看文件，并等待下载完成':'Please view the file below the browser and wait for the download to complete'), 10);

    //                 }).catch(e => {
    //                     unmask();
    //                     console.log(e);
    //                     Modal.error({ title: langValue==0?'出错了Error':(langValue==1?'出错了':'Error') })
    //                 });
    //             }

    //         },
    //         () => { }, null);

    // }
    const handleDownload = () => {
        mask()
        try {
            let excelData = [];
            let arr = servedBillCol.slice(0, 21)
            let ch_title_arr = []
            let en_title_arr = []
            arr.forEach(item => {
                ch_title_arr.push(item.ch_title)
                en_title_arr.push(item.en_title)
            })
            if (langValue == 2) {
                excelData.push(en_title_arr)
            } else {
                excelData.push(ch_title_arr)
            }
            let len = data.length
            for (let i = 0; i < len; i++) {
                let bd = data[i]
                let row = [
                    // '',
                    // bd.转入开票点,
                    bd['交款人/单位'],
                    // bd.交款人类型,
                    bd.交款人手机号或电话号码,
                    bd.开票日期,
                    bd.开票人,
                    bd.合计金额,
                    bd.付款方式,
                    bd['项目1：转入项目'],
                    1,
                    bd.合计金额,
                    bd.备注,
                    bd.交款人地址,
                    bd.交款人邮箱,
                    // 捐赠款-xx和捐赠物-xx ，获取 -xx 如-慈善 -教育
                    bd.用途,
                    bd['项目1：自定义五'],
                    '君提',
                    bd.纳税人识别号,
                    bd.项目备注,
                    bd.票据号码,//
                    bd.序号
                ];
                excelData.push(row)
            }
            let fileName = (langValue == 2 ? 'Donation List ' : '捐款明细表 ') + '.xlsx';
            j2eUtil.j2e(excelData, fileName);
            unmask()
            message.info(langValue == 0 ? <>请在浏览器下方查看文件，并等待下载完成<br />Please view the file below the browser and wait for the download to complete</> : (langValue == 1 ? '请在浏览器下方查看文件，并等待下载完成' : 'Please view the file below the browser and wait for the download to complete'), 10);
        } catch (err) {
            console.log(err);
            unmask()
            message.error(langValue == 0 ? '下载失败Download failed' : (langValue == 1 ? '下载失败' : 'Download failed'), 2);
        }

    }
    const numberChangeHandle = (e) => {
        setNumber(e.target.value.trim())
    }
    const startNumberChangeHandle = (e) => {
        setStartnumber(e.target.value.trim())
    }
    const endNumberChangeHandle = (e) => {
        setEndnumber(e.target.value.trim())
    }
    const openOkHandle = async () => {
        try {


            if (isBatch) {
                if (!(/^\d+$/.test(start_number))) {
                    return message.warn(langValue == 0 ? <>起始号码请输入数字！<br />Please enter a number for the starting number!</> : (langValue == 1 ? '起始号码请输入数字！' : 'Please enter a number for the starting number!'))
                }
                if (!(/^\d+$/.test(end_number))) {
                    return message.warn(langValue == 0 ? <>终止号码请输入数字！<br />Please enter a number for the termination number!</> : (langValue == 1 ? '终止号码请输入数字！' : 'Please enter a number for the termination number!'))
                }
                var n1 = Number(start_number)
                var n2 = Number(end_number)
                if (n2 < n1) {
                    return message.warn(langValue == 0 ? <>终止号码不可以小于起始号码！<br />The termination number cannot be less than the starting number!</> : (langValue == 1 ? '终止号码不可以小于起始号码！' : 'The termination number cannot be less than the starting number!'))
                }
                var n = n2 - n1 + 1
                if (n < recordArr.length) {
                    return message.warn(langValue == 0 ? <>注意，批量打印票据过多，号码数无法满足！<br />Attention, there are too many tickets printed in bulk, and the number of numbers cannot be met!</> : (langValue == 1 ? '注意，批量打印票据过多，号码数无法满足！' : 'Attention, there are too many tickets printed in bulk, and the number of numbers cannot be met!'))
                }
                // 处理需更新的表据
                var numArr = []
                var arr = JSON.parse(JSON.stringify(recordArr))
                // 补零
                var zerolen = start_number.length - String(n1).length
                var zeroarr = new Array(zerolen).fill(0)
                var zerostr = zeroarr.join('')
                console.log(zerostr);
                arr.forEach(item => {
                    if (item['票据号码'] != (zerostr + String(n1))) {
                        numArr.push({
                            billDetailId: item['序号'],
                            number: zerostr + String(n1)
                        })
                        item['票据号码'] = zerostr + String(n1)
                    }
                    n1++
                })
                //   TODO else 需要 处理?
                let cdret = await axios.post('/fund/billmgt/checkDuplPrint', { startCode: start_number, endCode: end_number, billRecordId: props.recordId });
                if (cdret ?.data ) {
                    let d = cdret.data;
                    if (d.length) {
                        let s = new Set();
                        d.forEach(e => {
                            if (e.bill_codes) {
                                let bc = e.bill_codes.split(',');
                                s.add(bc);
                            }
                        });
                        let arrStr = Array.from(s).join(',');


                        await new Promise((resolve, reject) => {
                            Modal.confirm({
                                title: '以下号码近期已输入过，请先确认实际无重复打印。The following numbers have been entered recently，Please verify that there is no duplication before actual printing',
                                content: <h2>{arrStr}</h2>,
                                okText: '继续打印go on print',
                                cancelText: '取消 cancel',
                                async onOk() {
                                    resolve(); // 继续执行后续代码
                                },
                                onCancel() {
                                    reject({ msg: '用户取消' }); // 终止执行
                                }
                            });
                        });
                    }

                }

                if (numArr.length > 0) {
                    let data = await axios.post('/fund/billmgt/setTicketNumber', { numArr, billRecordId: props.recordId });
                    if (data ?.data) {
                        actionRef.current ?.reload()
                    const { msg, en_msg } = data.data
                        message.success(langValue == 0 ? <>{msg}<br />{en_msg}</> : (langValue == 1 ? msg : en_msg))
                    } else {
                        return message.error(langValue == 0 ? <>票据号码写入错误<br />Bill number writing error</> : (langValue == 1 ? '票据号码写入错误' : 'Bill number writing error'))
                    }
                }

                setRecordArr(arr)
                setOpen(false)
                setModalVisible(true)
            } else {
                if (/^[\d\-]+$/.test(number)) {
                    var arr = JSON.parse(JSON.stringify(recordArr))
                    if (arr[0]['票据号码'] == number) {

                    } else {
                        arr[0]['票据号码'] = number
                        var numArr = [{
                            billDetailId: arr[0]['序号'],
                            number
                        }]
                        let data = await axios.post('/fund/billmgt/setTicketNumber', { numArr, billRecordId: props.recordId });
                        const { msg, en_msg, code } = data.data
                        if (code == -1) {
                            return message.error(langValue == 0 ? <>票据号码写入错误<br />Bill number writing error</> : (langValue == 1 ? '票据号码写入错误' : 'Bill number writing error'))
                        }
                        actionRef.current ?.reload()
                    message.success(langValue == 0 ? <>{msg}<br />{en_msg}</> : (langValue == 1 ? msg : en_msg))

                    }

                    setRecordArr(arr)
                    setOpen(false)
                    setModalVisible(true)
                } else {
                    message.warn('请输入数字！')
                }
            }

        } catch (e) {
            console.log('error:', e)
            if (e ?.msg == '用户取消') {
                setOpen(false)//关闭输入票据号弹窗
                return;
            }
        }

    }
    // 批量预览发票 
    const allInvoiceDownload = () => {
        if (selectedRowArr.length < 1) {
            var str = langValue == 0 ? '未选择票据！No ticket selected!' : (langValue == 1 ? '未选择票据！' : 'No ticket selected!')
            message.warning(str)
            return
        }
        setIsbatch(true)
        setOpen(true)
        setStartnumber(selectedRowArr[0]['票据号码'])
        setEndnumber(selectedRowArr[selectedRowArr.length - 1]['票据号码'])
        setRecordArr(selectedRowArr)
        // setModalVisible(true)
    }
    // 预览发票 
    const openInvoiceBox = (record) => {
        // console.log(recordArr);
        var arr = []
        arr.push(record)
        setRecordArr(arr)
        setNumber(record['票据号码'])
        // if(record['票据号码']){
        //     // 已有票据号码，预览
        //     setModalVisible(true)
        // }else {
        //     // 输入票据号码
        //     setOpen(true)
        // }
        setIsbatch(false)
        setOpen(true)
        // setModalVisible(true)

    }
    // 打印单张发票
    const InvoicePrint = () => {
        // 转换虚拟尺寸为物理尺寸
        // const regex = /\b\d+(?:\.\d+)?px\b/g
        // let arr = htmlstyle.split(regex)
        // console.log(arr);
        // let matches = [...htmlstyle.matchAll(regex)]
        // let stylestr = htmlstyle
        // matches.forEach((match,index)=>{
        //     // 转换物理尺寸
        //     let num = Number(match[0].split('p')[0])
        //     let newnum = (num*3/4) + 'pt'
        //     let str = stylestr.slice(0,match.index)
        //     let len = match[0].length
        //     let str2 = stylestr.slice(index+len)
        //     stylestr = str+newnum+str2
        //     console.log(`第 ${index + 1} 个匹配项: "${match[0]}" 在索引 ${match.index}`)
        // })
        // console.log(stylestr);
        printJS({
            printable: 'htmlstr',
            type: 'html',
            targetStyles: ['*'],
            documentTitle: `发票`,
            scanStyles: false,
            style: htmlstyle
        })
        // setModalVisible(false)
    }
    const getColumns = (col) => {
        let newCol = [...col];
        let operCol = {
            title: '操作',
            en_title: 'Operation',
            ch_title: '操作',
            valueType: 'option',
            render: (text, record, _, action) => {
                return [
                    <a
                        key="print"
                        onClick={() => openInvoiceBox(record)}
                    >
                        {langValue == 0 ? '打印Print' : (langValue == 1 ? '打印' : 'Print')}
                    </a>,
                ]
            },
        };
        newCol.push(operCol)
        newCol.forEach(item => {
            if (item.dataIndex == '状态') {
                item.render = (_, item2) => {
                    return langValue == 0 ? <span>{item2.ch_status}<br />{item2.en_status}</span> : (langValue == 1 ? item2.ch_status : item2.en_status)
                }
            }
            item.title = langValue == 0 ? <>{item.ch_title}<br />{item.en_title}</> : (langValue == 1 ? item.ch_title : item.en_title)
        })
        return newCol;
    }

    return (
        <div className="bill-mgt">
            <div className="base-info">
                <div className='bill-mgt-nav'>
                    <span className='content'>{langValue == 0 ? '已处理列表(Processed list)' : (langValue == 1 ? '已处理列表' : 'Processed list')}{'>'}{langValue == 0 ? '查看(View)' : (langValue == 1 ? '查看' : 'View')}</span>
                    <Button className='back-button' type='link'
                        onClick={() => { props.setModalVisible(false) }}>
                        <RollbackOutlined style={{ fontSize: '16px', fontWeight: '1900', color: '#08c' }} />
                        {langValue == 0 ? '返回Return' : (langValue == 1 ? '返回' : 'Return')}
                    </Button>
                </div>
                <h1 className="info-title">
                    {langValue == 0 ? '基础信息 Basic Information' : (langValue == 1 ? '基础信息' : 'Basic Information')}
                </h1>
                <div className='bi-content'>
                    <div className='bc-item'>
                        <span>{langValue == 0 ? '生成日期(Date Generated)' : (langValue == 1 ? '生成日期' : 'Date Generated')}：</span>
                        <span>{props.recordDate}</span>
                    </div>
                    <div className='bc-item'>
                        <span>{langValue == 0 ? '地区(Region)' : (langValue == 1 ? '地区' : 'Region')}：</span>
                        <span>{props.recordArea}</span>
                    </div>
                    <div className='bc-item'>
                        <span>{langValue == 0 ? '志工人数(Number of Volunteers)' : (langValue == 1 ? '志工人数' : 'Number of Volunteers')}：</span>
                        <span>{props.recordVolCnt}</span>
                    </div>
                </div>
            </div>
            <div className="bill-info">
                <div className="info-title">
                    <span>{langValue == 0 ? '票据信息 Ticket information' : (langValue == 1 ? '票据信息' : 'Ticket information')}</span>
                    <div className='oper-wrapper'>
                        <Button className='download-btn' type='primary' icon={<DownloadOutlined />}
                            onClick={allInvoiceDownload} >{langValue == 0 ? '批量打印Batch print' : (langValue == 1 ? '批量打印' : 'Batch print')}</Button>
                        <Button className='download-btn' type='primary' icon={<DownloadOutlined />}
                            onClick={handleDownload} >{langValue == 0 ? '下载Download' : (langValue == 1 ? '下载' : 'Download')}</Button>
                        {/* <Upload
                            // beforeUpload={handleUpload}
                            beforeUpload={(file) => {
                                handleUpload(file, props.recordId);
                                return false; // 取消组件本身的上传动作
                            }}
                            showUploadList={false}
                            maxCount={1}
                        >
                            <Button type='primary' className='upload-btn' icon={<UploadOutlined />}>{langValue==0?'导入Import':(langValue==1?'导入':'Import')}</Button>

                        </Upload > */}
                    </div>
                </div>
                <div className='svrd-query-table-container'>

                    <ProTable
                        //将已作废的行标红
                        rowClassName={(record) => {
                            if (record.状态 == '已作废') {
                                // console.log('rowClassName:', record);
                                return 'table-row-color';
                            }
                            return ''
                        }}
                        tableAlertRender={({ selectedRowKeys, selectedRows, onCleanSelected }) => (
                            <Space size={24}>
                                <span>
                                    {langValue == 0 ? `已选${selectedRowKeys.length}项 Selected ${selectedRowKeys.length} items` : (langValue == 1 ? `已选${selectedRowKeys.length}项` : `Selected ${selectedRowKeys.length} items`)}

                                    {selectedRowKeys.length ? (<a style={{ marginLeft: 8 }} onClick={onCleanSelected}>
                                        {langValue == 0 ? '取消选择Unselected' : (langValue == 1 ? '取消选择' : 'Unselected')}
                                    </a>) : null}

                                </span>
                            </Space>
                        )}
                        rowSelection={{
                            alwaysShowAlert: true,
                            onChange: (selectedRowKeys, selectedRows) => {
                                // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                                setSelectedRowkeysArr([...selectedRowKeys]);
                                setSelectedRowArr([...selectedRows]);
                            },
                        }}
                        sticky
                        bordered
                        style={{ minWidth: '150rem' }}
                        columns={getColumns(columns)}
                        actionRef={actionRef}
                        // scroll={{
                        //     x: 960,
                        // }}
                        toolBarRender={false}
                        //工具栏选项
                        options={{
                            density: true,
                            fullScreen: true,
                            reload: false,
                            setting: true,
                        }}
                        request={async (
                            // 第一个参数 params 查询表单和 params 参数的结合
                            // 第一个参数中一定会有 pageSize 和  current ，这两个参数是 antd 的规范
                            params,
                            sort,
                            filter,
                        ) => {
                            // 这里需要返回一个 Promise,在返回之前你可以进行数据转化
                            // 如果需要转化参数可以在这里进行修改
                            // console.log('pro table params:', params, ' sort:', sort, ' filter:', filter);
                            const coverParams = (params) => {
                                let p = { ...params, uid: sessionStorage.getItem('uid') };
                                // console.log('rcdId:', props.recordId)
                                p = { ...p, billRecordId: props.recordId, keyword: params['交款人/单位'] };

                                // console.log('coverParams:', p);
                                return p;
                            }

                            const result = await axios.post('/fund/billmgt/queryBillRecordById', coverParams(params));
                            const data = result.data.data;
                            // console.log("billmgt record list data:", data);
                            let dataSrc = [...data];
                            dataSrc.forEach((d, i) => {
                                // d.key = i + 1;
                                // d['序号'] = i + 1;
                                d.key = d['序号'];
                                d.ch_status = d['状态']
                                d.en_status = statusObj2[d.ch_status]
                                // d._id = i + 1;
                            });
                            setData(dataSrc)
                            if (needSearchForm) {
                                //动态搜索表单，只在首次交互加载
                                let col = [...columns.slice()];
                                col.forEach((c, i) => {
                                    if (i != 2) {
                                        c.renderFormItem = () => { return false };
                                    }
                                })
                                setNeedSearchForm(false);
                                setColumns(col);
                            }

                            return {
                                data: dataSrc,
                                // success 请返回 true，
                                // 不然 table 会停止解析数据，即使有数据
                                success: true,
                                // 不传会使用 data 的长度，如果是分页一定要传
                                total: dataSrc.length,
                            };
                        }}
                        editable={{
                            type: 'multiple',
                        }}
                        columnsState={{
                            persistenceKey: 'pro-table-singe-demos',
                            persistenceType: 'sessionStorage',
                        }}
                        rowKey="序号"
                        search={{
                            labelWidth: 'auto',
                            span: '5',
                            collapseRender: false,//隐藏收起按钮
                            searchText: langValue == 0 ? '查询Query' : (langValue == 1 ? '查询' : 'Query'),
                            resetText: langValue == 0 ? '重置Reset' : (langValue == 1 ? '重置' : 'Reset'),
                        }}
                        // search={false}
                        pagination={{
                            pageSize: 10,
                            pageSizeOptions: [10, 20, 50, 100, 1000],
                            showQuickJumper: true,
                            showSizeChanger: true,
                        }}
                        dateFormatter="string"
                        // headerTitle="已处理票据明细"
                        onRequestError={(error) => {
                            error = typeof error == 'object' ? JSON.stringify(error) : error;
                            Modal.error({ title: '表格加载错误' });
                        }}
                    />
                </div>
                <Button className='back-button-bottom' type='link' style={{ position: 'absolute', right: '20px', fontWeight: '600', fontSize: '16px' }}
                    onClick={() => { props.setModalVisible(false) }}>
                    <RollbackOutlined style={{ fontSize: '16px', fontWeight: '1900', color: '#08c' }} />
                    {langValue == 0 ? '返回Return' : (langValue == 1 ? '返回' : 'Return')}
                </Button>
            </div>
            <Modal
                centered
                visible={modalVisible}
                onOk={InvoicePrint}
                okText={langValue == 0 ? '打印Print' : (langValue == 1 ? '打印' : 'Print')}
                cancelText={langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle')}
                onCancel={() => setModalVisible(false)}
                width={'auto'}
                destroyOnClose={true}//关闭时清空（重新加载子组件）
                maskClosable={false}//点击遮罩不关闭
                closable={false}//不显示右上角的关闭按钮（X)
            >
                <Invoice recordArr={recordArr} />
            </Modal>
            <Modal
                centered
                visible={open}
                onOk={openOkHandle}
                onCancel={() => setOpen(false)}
                title={langValue == 0 ? '输入票据号码Enter the ticket No.' : (langValue == 1 ? '输入票据号码' : 'Enter the ticket number')}
                cancelText={langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle')}
                okText={langValue == 0 ? '预览票据Preview receipts' : (langValue == 1 ? '预览票据' : 'Preview receipts')}>
                {isBatch ?
                    <>
                        <div>起始号码Start No.：<Input placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} onChange={startNumberChangeHandle} value={start_number} /></div>
                        <div>终止号码End No.：<Input placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} onChange={endNumberChangeHandle} value={end_number} /></div>
                    </> :
                    <Input placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} onChange={numberChangeHandle} value={number} />}
            </Modal>
        </div>
    );
};     